import { useParams } from "react-router-dom";
import CityPage from "@/pages/CityPage";
import SalaryInCityPage from "@/pages/SalaryInCityPage";
import CanIAffordPage from "@/pages/CanIAffordPage";
import { Link } from "react-router-dom";

export default function DynamicPage() {
  const { pageSlug } = useParams();
  if (!pageSlug) return <NotFound />;

  if (pageSlug.startsWith('cost-of-living-in-')) {
    const citySlug = pageSlug.replace('cost-of-living-in-', '');
    return <CityPage citySlug={citySlug} />;
  }

  const salaryInMatch = pageSlug.match(/^(\d+)k-salary-in-(.+)$/);
  if (salaryInMatch) {
    return <SalaryInCityPage salary={parseInt(salaryInMatch[1]) * 1000} citySlug={salaryInMatch[2]} />;
  }

  const affordMatch = pageSlug.match(/^can-i-afford-(\d+)-rent-on-(\d+)k-in-(.+)$/);
  if (affordMatch) {
    return <CanIAffordPage rent={parseInt(affordMatch[1])} salary={parseInt(affordMatch[2]) * 1000} citySlug={affordMatch[3]} />;
  }

  const salaryTaxMatch = pageSlug.match(/^(\d+)k-salary-after-tax-in-(.+)$/);
  if (salaryTaxMatch) {
    return <SalaryInCityPage salary={parseInt(salaryTaxMatch[1]) * 1000} citySlug={salaryTaxMatch[2]} isTaxPage />;
  }

  return <NotFound />;
}

function NotFound() {
  return (
    <div className="container-main py-24 text-center" data-testid="not-found-page">
      <h1 className="text-4xl font-bold text-slate-900 mb-4">Page Not Found</h1>
      <p className="text-slate-500 mb-6">The page you're looking for doesn't exist.</p>
      <Link to="/" className="text-emerald-600 hover:text-emerald-700 font-medium">Back to Calculator</Link>
    </div>
  );
}
